import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="page-container not-found-page">
      <Helmet>
        <title>Page Not Found | Alpha APK Store</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      
      <h1>404 - Page Not Found</h1>
      <p>The page you're looking for doesn't exist or has been moved.</p>
      <Link to="/" className="back-btn">← Back to Home</Link>
    </div>
  );
}